import M$plugin$ThreeMapea from '/media/franjhigueras/MAPEA_VSCODE/mapea-publico/src/plugins/v5/threemapea/src/facade/js/threemapea';
import M$control$ThreeMapeaControl from '/media/franjhigueras/MAPEA_VSCODE/mapea-publico/src/plugins/v5/threemapea/src/facade/js/threemapeacontrol';
import M$impl$control$ThreeMapeaControl from '/media/franjhigueras/MAPEA_VSCODE/mapea-publico/src/plugins/v5/threemapea/src/impl/ol/js/threemapeacontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.ThreeMapea = M$plugin$ThreeMapea;
window.M.control.ThreeMapeaControl = M$control$ThreeMapeaControl;
window.M.impl.control.ThreeMapeaControl = M$impl$control$ThreeMapeaControl;
